import { useStore } from 'vuex'
import { toast } from 'vue3-toastify'
import ResultView from '@/views/ResultView.vue'
import FillingView from '@/views/tanker/FillingView.vue'
import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'marketplace',
      component: () => import('@/views/marketplace/MarketplaceView.vue'),
      children: [
        {
          path: '/marketplace/:brand/:store?',
          name: 'market-details',
          component: () => import('@/views/marketplace/MarketplaceDetailsView.vue')
        },
      ]
    },
    {
      path: '/card-status-check',
      name: 'card-status-check',
      component: () => import('@/views/CardStatusCheck.vue'),
    },
    {
      path: '/tanker/result/:store/:station/:column/:fuel/:capacity/:uuid',
      name: 'tanker-result',
      component: () => import('@/views/tanker/ResultView.vue')
    },
    {
      path: '/tanker/filling/:store/:station/:column/:fuel/:capacity/:uuid',
      name: 'tanker-filling',
      component: () => FillingView
    },
    {
      path: '/tanker/:store/:station/:column?',
      name: 'tanker',
      component: () => import('@/views/tanker/TankerView.vue')
    },
    // {
    //   path: '/parking/:id',
    //   name: 'parking',
    //   component: () => import('@/views/parking/ParkingView.vue')
    // },
    {
      path: "/app-auth",
      name: "AuthPage",
      component: () => import('@/views/AppAuthView.vue'),
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('@/views/AccountPage.vue'),
    },
    {
      path: '/account/auth',
      name: 'accountAuth',
      component: () => import('@/views/AccountAuth.vue'),
    },
    {
      path: '/demo',
      name: 'demo',
      // component: () => import('@/views/DemoView.vue'),
      redirect: "/p/6?a=5000&c=123&o=123&b=123",
    },
    {
      path: '/demo/payment',
      name: 'demoPayment',
      component: () => import('@/views/DemoPayment.vue')
    },
    {
      path: '/multikassa',
      name: 'multikassa',
      component: () => import('@/views/MultikassaView.vue'),
    },
    {
      path: '/application-links',
      name: 'application-links',
      component: () => import('@/views/ApplicationLinksView.vue'),
    },
    {
      path: '/result',
      name: 'result',
      component: ResultView
    },
    {
      path: '/receipt/:uuid',
      name: 'receipt',
      component: () => import('@/views/ReceiptView.vue')
    },
    {
      path: '/invoice/:uuid',
      name: 'invoice',
      component: () => import('@/views/checkout/CheckoutView.vue'),
    },
    {
      path: '/soliq-services/:region',
      name: 'soliq-services',
      component: () => import('@/views/ServicesView.vue')
    },
    {
      path: '/qr-online',
      name: 'qrOnline',
      component: () => import('@/views/qr/QrOnline.vue')
    },
    {
      path: '/static/:store',
      name: 'static',
      component: () => import('@/views/static/StaticView.vue'),
    },
    {
      path: '/static/:store/last',
      name: 'last-invoice',
      component: () => import('@/views/checkout/LastInvoiceView.vue'),
    },
    {
      path: '/subscribe/:subscriber',
      name: 'subscription',
      component: () => import('@/views/subscriptions/SubscribeView.vue'),
    },
    {
      path: '/resubscribe/:subscriber',
      name: 'resubscribe',
      component: () => import('@/views/subscriptions/ResubscribeView.vue'),
    },
    {
      path: '/m/:brand',
      name: 'tables',
      component: () => import('@/views/menu/TableView.vue'),
    },
    {
      path: '/m/:brand/:table',
      name: 'menu',
      component: () => import('@/views/menu/MenuView.vue'),
    },
    {
      path: '/order-table/:table?',
      name: 'order-table-view',
      component: () => import('@/views/menu/OrderView.vue'),
    },
    {
      path: '/order/:type/:store/:guid?',
      name: 'order-view',
      component: () => import('@/views/takeaway/OrderView.vue'),
    },
    {
      path: '/t/:brand/:store',
      name: 'takeaway',
      component: () => import('@/views/takeaway/TakeawayView.vue')
    },
    {
      path: '/s/:store',
      name: 'store',
      component: () => import('@/views/StoreView.vue'),
    },
    {
      path: '/pos/:terminal',
      name: 'precheck-redirect',
      component: () => import('@/views/precheck/RedirectView.vue'),
    },
    {
      path: '/p/:terminal',
      name: 'precheck',
      component: () => import('@/views/precheck/PrecheckView.vue'),
    },
    {
      path: '/p/:pos/:device/:receipt',
      name: 'pos',
      component: () => import('@/views/precheck/PosView.vue'),
    },
    {
      path: '/r/:terminal/:order?',
      name: 'review',
      component: () => import('@/views/review/ReviewView.vue'),
    },
    {
      path: '/y/:store',
      name: 'vending',
      component: () => import('@/views/vending/VendingView.vue'),
    },
    {
      path: '/u/:store/:order?',
      name: 'fastpay',
      component: () => import('@/views/fastpay/FastPayView.vue'),
    },
    {
      path: '/:employee/:review?',
      name: 'tips',
      component: () => import('@/views/tips/TipsView.vue'),
    },
    {
      path: '/qr/:id',
      name: 'qr',
      component: () => import('@/views/qr/QrView.vue'),
    },
    {
      path: '/useragent',
      name: 'useragent',
      component: () => import('@/views/UseragentView.vue'),
    },
    // }
    // {
    //   path: '/callback-test',
    //   name: 'callback',
    //   component: () => import('@/views/callback.vue')
    // },
    {
      path: "/*",
      redirect: "https://app.rhmt.uz",
    }
  ]
})

router.afterEach((to) => {
  const store = useStore()
  store.commit('SET_CURRENT_ROUTE', to)
})

const CHUNK_ERROR_RE = /Unable to preload CSS|Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i

const UPDATE_MESSAGES = {
  ru: 'Приложение обновилось. Нажмите, чтобы открыть страницу заново',
  uz: 'Ilova yangilandi. Sahifani qayta oching',
  en: 'The app has been updated. Tap to reopen the page'
}

router.onError((error, to) => {
  if (!CHUNK_ERROR_RE.test(error?.message ?? '')) return

  let locale = 'ru'
  try { locale = localStorage.getItem('locale') || 'ru' } catch { /* webview без storage */ }

  toast.error(UPDATE_MESSAGES[locale] ?? UPDATE_MESSAGES.ru, {
    toastId: 'chunk-load-error',
    autoClose: false,
    closeOnClick: true,
    transition: toast.TRANSITIONS.SLIDE,
    position: toast.POSITION.TOP_CENTER,
    onClick: () => window.location.assign(to?.fullPath ?? window.location.href)
  })
})

export default router
